import React, { useState } from "react";
import { Panel } from "primereact/panel";
import "./FAQ.css";

export default function FAQSection() {
  const [activeIndex, setActiveIndex] = useState(null);

  const togglePanel = (index) => {
    setActiveIndex((prev) => (prev === index ? null : index));
  };

  const faqs = [
    {
      header: "What does an SQL Server DBA do?",
      content:
        "A DBA (Database Administrator) manages and maintains SQL Server databases, ensuring performance, security, and availability. They handle tasks like backups, updates, monitoring, and troubleshooting.",
    },
    {
      header: "Why is SQL Server database maintenance important?",
      content:
        "Regular maintenance ensures optimal performance, minimizes downtime, and safeguards data, reducing risks of data loss or corruption.",
    },
    {
      header: "Can a DBA help with SQL Server migrations?",
      content:
        "Yes, DBAs assist with migrating data to new SQL Server versions or cloud platforms, ensuring a seamless transition without data loss.",
    },
    {
      header: "Why choose managed SQL Server DBA services?",
      content:
        "Managed DBA services provide expert support, proactive maintenance, and 24/7 monitoring, reducing the burden on in-house IT teams.",
    },
    {
      header: "How can a DBA improve application performance?",
      content:
        "We offer email and WhatsApp support with every plan. Bonanza Plan customers also receive 24/7 system monitoring and priority support.",
    },

    {
      header: "Can a DBA assist with database design?",
      content:
        "Yes, DBAs play a crucial role in database design, including schema creation, normalization, and ensuring scalability. Their expertise ensures that databases are efficient and meet business needs.",
    },

  ];

  return (
    <>
      <div className="flex justify-content-center align-items-center faq-outer-container surface-ground">
        <div className="w-full sm:w-11 md:w-9 lg:w-9 mb-4">
                   <div
        className="mb-4 text-center Text-Gradient"
        style={{ fontFamily: "rockwell" }}
      >
        <h1 className="m-5">
          <b> Frequently Asked Questions</b>
        </h1>
      </div>
          <div
            className="card space-y-2"
            style={{ backgroundColor: "white", fontFamily: "rockwell" }}
          >
            {faqs.map((faq, index) => (
              <Panel
                key={index}
                header={faq.header}
                toggleable
                collapsed={activeIndex !== index}
                onToggle={() => togglePanel(index)}
                className="faq-panel" // for background color
                headerClassName="faq-header" // for header text size
              >
                {faq.content}
              </Panel>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
